import React, { useEffect, useState } from "react";
import { BellIcon } from "@heroicons/react/24/outline";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchNotifications } from "../../features/admin/PostsSlice";
import { fetchCategoryByType } from "../../features/admin/CategorySlice";

const animation = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  exit: { opacity: 0, y: 10, transition: { duration: 0.2 } },
};

const AdminNotificationCreatedStatisticCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");
  const { authNotifications: posts, authNotificationStatus: status } =
    useSelector((state) => state.posts);
  const { categories } = useSelector((state) => state.categories);

  const [approved, setApproved] = useState(0);
  const [total, setTotal] = useState(0);

  // Fetch notifications và categories
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchNotifications());
    }
    dispatch(fetchCategoryByType("notification,navbar,post,"));
  }, [dispatch, status]);

  // Lọc post là notification
  useEffect(() => {
    if (!posts || !categories) return;
    const filtered = posts.filter(
      (post) =>
        (userId == 1 ||
          categories.some((category) => category.id === post.categoryId)) &&
        post.type === "notification",
    );
    setTotal(filtered.length);
    setApproved(filtered.filter((p) => p.status === "published").length);
  }, [posts, categories, userId]);

  return (
    <motion.div
      {...animation}
      whileHover={{ scale: 1.04 }}
      className="w-full shadow-md sm:w-auto flex flex-col items-center text-center p-5 rounded-2xl border border-yellow-200  hover:border-yellow-300 transition-all cursor-pointer hover:shadow-lg"
      onClick={() => navigate("/admin/notification")}
    >
      <div className="p-3 bg-yellow-100 rounded-full mb-3 flex items-center justify-center">
        <BellIcon className="h-6 w-6 text-yellow-600" />
      </div>
      <p className="text-lg text-black mb-1">Hoạt động đã được duyệt</p>
      <p className="text-3xl font-bold text-black">
        <span className="">{approved}</span>
        <span className="text-3xl font-bold"> / </span>
        <span>{total}</span>
      </p>
    </motion.div>
  );
};

export default AdminNotificationCreatedStatisticCard;
